import styled from 'styled-components';

import ActionButton from 'components/ui/Button';

export const StyledActionButton = styled(ActionButton)`
  margin-left: 16px;
`;
